import icon from '../images/icons.svg';

export const previewBgc = [
  { previewName: 'none', src: `${icon}#icon-empty-bgc` },
  {
    previewName: 'image_1',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-1-desc_zfehcj.jpg',
  },
  {
    previewName: 'image_2',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-2-desc_frvbzp.jpg',
  },
  {
    previewName: 'image_3',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-3-desc_gcwevb.jpg',
  },
  {
    previewName: 'image_4',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-4-desc_ompb32.jpg',
  },
  {
    previewName: 'image_5',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-5-desc_wgkfmv.jpg',
  },
  {
    previewName: 'image_6',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-6-desc_ek3bra.jpg',
  },
  {
    previewName: 'image_7',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-7-desc_snpkd6.jpg',
  },
  {
    previewName: 'image_8',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-8-desc_ie4oqo.jpg',
  },
  {
    previewName: 'image_9',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-9-desc_ej6is5.jpg',
  },
  {
    previewName: 'image_10',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-10-desc_tvcudp.jpg',
  },
  {
    previewName: 'image_11',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-11-desc_ddsqdj.jpg',
  },
  {
    previewName: 'image_12',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-12-descup_rlzkvu.jpg',
  },
  {
    previewName: 'image_13',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-13-desc_yq59jp.jpg',
  },
  {
    previewName: 'image_14',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-14-desc_vaufhq.jpg',
  },
  {
    previewName: 'image_15',
    src: 'https://res.cloudinary.com/dhs2bnhrk/image/upload/c_fill,w_28,h_28/pic-15-desc_dhafxb.jpg',
  },
];

export const icons = [
  { iconName: 'icon_1', svg: `${icon}#icon-train` },
  { iconName: 'icon_2', svg: `${icon}#icon-heart` },
  { iconName: 'icon_3', svg: `${icon}#icon-beach` },
  { iconName: 'icon_4', svg: `${icon}#icon-cap` },
  { iconName: 'icon_5', svg: `${icon}#icon-laptop` },
  { iconName: 'icon_6', svg: `${icon}#icon-chat` },
  { iconName: 'icon_7', svg: `${icon}#icon-tv` },
  { iconName: 'icon_8', svg: `${icon}#icon-bag` },
];

export const priorities = [
  { priorityLevel: 'low', color: '#4caf50' },
  { priorityLevel: 'medium', color: '#ff9800' },
  { priorityLevel: 'high', color: '#f44336' },
  { priorityLevel: 'none', color: '#3a3a3a' },
];